(function () {
  "use strict";

  window.UA_CATALOG = window.UA_CATALOG || {};

  function buildUrlForEndpoint(state, endpoint) {
    var url = new URL(endpoint, window.location.origin);
    var params = new URLSearchParams();

    params.set("categoryId", state.filters.categoryId || "ALL");
    params.set("page", String(state.page));
    params.set("pageSize", String(state.pageSize));

    if (state.excludeSpecialty === true) {
      params.set("excludeSpecialty", "true");
    }

    ["brand", "color", "size", "search", "tag"].forEach(function (key) {
      var value = state.filters[key];
      if (value) params.set(key, value);
    });

    url.search = params.toString();
    return url.toString();
  }

  function buildUrl(state) {
    return buildUrlForEndpoint(state, state.endpoint);
  }

  function requestCredentials(url) {
    try {
      return new URL(url, window.location.origin).origin === window.location.origin
        ? "same-origin"
        : "omit";
    } catch (_error) {
      return "omit";
    }
  }

  async function fetchWithFallback(primaryUrl, fallbackUrl, options) {
    options = options || {};

    async function run(url) {
      var requestOptions = Object.assign({}, options, {
        credentials: requestCredentials(url)
      });

      var response = await fetch(url, requestOptions);

      if (!response.ok) {
        throw new Error("Request failed with status " + response.status + " for " + url);
      }

      return response;
    }

    try {
      return await run(primaryUrl);
    } catch (primaryError) {
      if (primaryError && primaryError.name === "AbortError") {
        throw primaryError;
      }

      if (!fallbackUrl || fallbackUrl === primaryUrl) {
        throw primaryError;
      }

      console.warn(
        "[UA Catalog API] Shopify App Proxy request failed; trying direct API fallback.",
        primaryError
      );

      return run(fallbackUrl);
    }
  }

  function cacheKey(state) {
    return JSON.stringify({
      page: state.page,
      pageSize: state.pageSize,
      excludeSpecialty: state.excludeSpecialty === true,
      filters: state.filters
    });
  }

  window.UA_CATALOG.api = {
    loadPage: async function loadPage(state) {
      var key = cacheKey(state);

      if (state.cache.has(key)) {
        return state.cache.get(key);
      }

      if (state.requestController) {
        state.requestController.abort();
      }

      state.requestController = new AbortController();

      var fallbackEndpoint =
        state.root && state.root.dataset
          ? (state.root.dataset.apiFallbackEndpoint || "")
          : "";

      var response = await fetchWithFallback(
        buildUrl(state),
        fallbackEndpoint
          ? buildUrlForEndpoint(state, fallbackEndpoint)
          : "",
        {
          method: "GET",
          headers: { "Accept": "application/json" },
          signal: state.requestController.signal
        }
      );

      var payload = await response.json();

      if (!payload || payload.success !== true) {
        throw new Error(payload && payload.error ? payload.error : "Catalog response was invalid.");
      }

      state.cache.set(key, payload);
      return payload;
    },

    loadCategories: async function loadCategories(state) {
      if (!state.categoriesEndpoint) return [];

      var categoriesFallbackEndpoint =
        state.root && state.root.dataset
          ? (state.root.dataset.categoriesFallbackEndpoint || "")
          : "";

      var response = await fetchWithFallback(
        new URL(state.categoriesEndpoint, window.location.origin).toString(),
        categoriesFallbackEndpoint
          ? new URL(categoriesFallbackEndpoint, window.location.origin).toString()
          : "",
        {
          method: "GET",
          headers: { "Accept": "application/json" }
        }
      );

      var payload = await response.json();

      if (!payload || payload.success !== true) {
        throw new Error(payload && payload.error ? payload.error : "Category response was invalid.");
      }

      return payload.categories || payload.data || [];
    },

    loadPackages: async function loadPackages(state) {
      if (!state.packagesEndpoint) return [];

      var packagesFallbackEndpoint =
        state.root && state.root.dataset
          ? (state.root.dataset.packagesFallbackEndpoint || "")
          : "";

      var response = await fetchWithFallback(
        new URL(state.packagesEndpoint, window.location.origin).toString(),
        packagesFallbackEndpoint
          ? new URL(packagesFallbackEndpoint, window.location.origin).toString()
          : "",
        {
          method: "GET",
          headers: { "Accept": "application/json" },
          cache: "no-store"
        }
      );

      var payload = await response.json();

      if (!payload || payload.success !== true) {
        throw new Error(payload && payload.error ? payload.error : "Package response was invalid.");
      }

      return Array.isArray(payload.packages) ? payload.packages : [];
    },

    preloadNext: function preloadNext(state) {
      if (!state.currentResponse || !state.currentResponse.hasNext) return;

      var currentPage = state.page;
      state.page = currentPage + 1;

      var key = cacheKey(state);
      state.page = currentPage;

      if (state.cache.has(key)) return;

      var preloadState = {
        endpoint: state.endpoint,
        page: currentPage + 1,
        pageSize: state.pageSize,
        filters: Object.assign({}, state.filters),
        excludeSpecialty: state.excludeSpecialty === true,
        cache: state.cache,
        requestController: null
      };

      var run = function () {
        window.UA_CATALOG.api.loadPage(preloadState).catch(function () {});
      };

      if ("requestIdleCallback" in window) {
        window.requestIdleCallback(run, { timeout: 1800 });
      } else {
        window.setTimeout(run, 500);
      }
    }
  };
})();
/* UNISOURCE_CATALOG_API_APP_PROXY_FALLBACK_V1 */